/**
 * SetupChecklist — three-step "Set up Relay on this Mac" strip at the top of
 * the Team page. Collapses to one "This Mac is set up" line when the key
 * exists (and is no longer in its just-created state) and a Relay Helper is
 * running. Step 3 is optional and never marked done: nothing yet says when an
 * AI chat counts as connected (spec #66501 change 8).
 */
import { relativeTime } from "./useHelperStatus";

function jump(id: string) {
  document.getElementById(id)?.scrollIntoView?.({ behavior: "smooth" });
}

export function SetupChecklist({
  keyExists, keyJustCreated, helperOnline, lastHeartbeat,
}: {
  keyExists: boolean;
  keyJustCreated: boolean;
  helperOnline: boolean;
  lastHeartbeat: string | null;
}) {
  const keyDone = keyExists && !keyJustCreated;
  if (keyDone && helperOnline) {
    const rel = relativeTime(lastHeartbeat);
    return (
      <div id="team-section-setup" className="tp-setup-done" style={{ marginBottom: 24 }}>
        <span className="tp-dot" />
        <strong>This Mac is set up</strong>
        <span className="tp-small">Relay Helper running{rel ? ` · last check-in ${rel}` : ""}</span>
      </div>
    );
  }

  const steps = [
    { n: 1, done: keyDone, title: "Create your key", desc: keyDone ? "Done" : "Lets Relay Helper and your AI chats act as you", target: "team-section-my-key" },
    { n: 2, done: helperOnline, title: "Run Relay Helper", desc: helperOnline ? "Running" : "Paste your key, pick projects, click Start", target: "team-section-helper" },
    { n: 3, done: false, title: "Connect an AI chat", desc: "Optional. Talk to the team from Claude.ai, Gemini or ChatGPT", target: "team-section-mcp" },
  ];

  return (
    <section id="team-section-setup" style={{ marginBottom: 24 }}>
      <div className="sc-section-label">Set up Relay on this Mac</div>
      <div className="tp-checklist">
        {steps.map((s) => (
          <button key={s.n} className={`tp-check${s.done ? " done" : ""}`} onClick={() => jump(s.target)}>
            <span className="tp-check-num">{s.done ? "✓" : s.n}</span>
            <span>
              <div className="tp-check-title">{s.title}</div>
              <div className="tp-check-desc">{s.desc}</div>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
